import React, { ReactNode, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { AppDispatch, RootState } from "../../redux/store";
import { fetchMaintenanceStatus } from "../../redux/slices/maintenanceSlice";

interface ProtectedRouteProps {
  allowedRoles: Array<"ENTERPRISE" | "ADMIN" | "CUSTOMER" | "SUPERADMIN" | "REVIEWER">;
  children?: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles,
  children,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { currentUser } = useSelector((state: RootState) => state.auth);
  const { isInMaintenance, isLoading } = useSelector(
    (state: RootState) => state.maintenance
  );
  const isCustomer = currentUser?.role?.role_code === "CUSTOMER";

  useEffect(() => {
    dispatch(fetchMaintenanceStatus());
  }, [dispatch]);

  // Loading while checking maintenance
  if (isLoading) {
    return null;
  }

  // Redirect CUSTOMER to maintenance page if in maintenance mode
  if (isInMaintenance && isCustomer) {
    return <Navigate to="/maintenance" replace />;
  }

  if (
    currentUser &&
    currentUser.role?.role_code &&
    !allowedRoles.includes(currentUser.role.role_code)
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
